<template>
  <v-container>
    <v-row>
      <v-col v-for="(item, i) in publicStudyLists" :key="i" cols="12" sm="6">
        <v-card
          flat
          :to="{ name: 'StudyListDetail', params: { id: item.id.toString() } }"
        >
          <v-card-title v-text="item.name"></v-card-title>

          <v-card-subtitle
            v-text="
              `${item.item_count} ${pluralize(
                item.item_count,
                'term',
                'terms'
              )}`
            "
          ></v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PublicLists",

  methods: {
    ...mapActions(["fetchPublicStudyLists", "play", "updatePlayingInfo"]),
    pluralize(n, singular, plural) {
      return n !== 1 ? plural : singular;
    },
  },

  computed: mapGetters(["publicStudyLists"]),

  created() {
    this.fetchPublicStudyLists();
  }

};
</script>
